import swal from 'sweetalert';
import { toast } from 'react-toastify';

export function SUCCESS_MESSAGE(message, options = {}){
  toast.success(message, options);
}
export function ERROR_MESSAGE(message, options = {}){
  toast.error(message, options);
}

export function  DELETE_ALERT() {
    return new Promise((resolve) => {
      swal({
        title: "Are you sure?",
        text: "Are you sure to Delete?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };

  export function  DELETE_ALERT_() {
    return new Promise((resolve) => {
      swal({
        title: "Are you sure?",
        text: "Please select atleast one id",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };

  export function  CORRECT_ANSWER() {
    return new Promise((resolve) => {
      swal({
        title: "Please select correct answer",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };

  export function  SELECT_CORRECT_FILE() {
    return new Promise((resolve) => {
      swal({
        text: "Selected file not allowed to upload",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };
  export function  FILE_TOO_LARGE() {
    return new Promise((resolve) => {
      swal({
        text: "Selected video size too long",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };
  export function  CSV_TEXT() {
    return new Promise((resolve) => {
      swal({
        text: "Import successfully",
        icon: "success",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };

  export function CONFIRM_POPUP(confirmMsg, options = {}) {
    return new Promise((resolve) => {
      swal({
        title: "Are you sure?",
        text: confirmMsg,
        icon: "warning",
        buttons: true,
        dangerMode: false,
        ...options,
      }).then((isConfirmed) => {
        resolve(isConfirmed);
      });
    });
  };

  export function PROMISE_TOAST(request, messages = {}, toastId, options = {}) {
    let defaultMessages = {
      pending: 'Saving...',
      success: 'Saved',
      error: 'Failed to save'
    }
    messages = {
      ...defaultMessages,
      ...messages
    }

    let defaultOptions = {
      toastId
    }
    options = {
      ...defaultOptions,
      ...options
    }
    return toast.promise(request, messages, options)
  }

  export function REFUND_ALERT() {
  return new Promise((resolve) => {
    swal({
      title: "Paid Appointment",
      content: (() => {
    const div = document.createElement("div");
    div.innerHTML = `
    <div class="text-center">
      <p>This appointment includes a payment. You can cancel with a <strong>full refund</strong> or <strong>no refund</strong>.</p>
      </div>
    `;
    return div;
  })(),buttons: {
        cancel: "Close",
        withoutRefund: {
          text: "Cancel without Refund",
          value: "cancel_without_refund",
          className: "d-flex align-items-center justify-content-center btnSm commonBtn"
        },
        withRefund: {
          text: "Cancel with Refund",
          value: "cancel_with_refund",
          className: "d-flex align-items-center justify-content-center btnSm commonBtn"
        },
      },
      icon: "warning",
      }).then((value) => {
        resolve(value); // cancel_with_refund or cancel_without_refund or null
      });
    });
  }